import type { IconSize } from "@similarweb/icons";
import type { ReactNode } from "react";

import { NotificationBannerTheme, StyledIcon, StyledNotificationBanner } from "./styles";
import type { NotificationType } from "./types";

type Props = {
    className?: string;
    iconSize?: IconSize;
    children: ReactNode;
    notificationType: NotificationType;
};

const NotificationBanner = ({ className, iconSize = "xs", children, notificationType }: Props) => {
    const bannerTheme = NotificationBannerTheme[notificationType];

    return (
        <StyledNotificationBanner
            className={className}
            theme={bannerTheme}
        >
            <StyledIcon
                theme={bannerTheme}
                iconName={bannerTheme.iconName}
                size={iconSize}
            />
            {children}
        </StyledNotificationBanner>
    );
};

export default NotificationBanner;
